import FileCreate from './FileCreate'



export default {
    create: FileCreate,
   
};
